/**
 * Returns the Chile states list to populate the select item.
 */
export function gluky_addressfield_cl_states_list() {
  let temporalStates = [];
  const states = {
    '11': 'Tarapacá',
    '22': 'Antofagasta',
    '31': 'Atacama',
    '41': 'Coquimbo',
    '51': 'Valparaíso',
    '61': "O'Higgins",
    '71': 'Maule',
    '81': 'Biobío',
    '91': 'Araucanía',
    '101': 'Los Lagos',
    '111': 'Aisén',
    '121': 'Magallanes',
    '131': 'RM Region Metropolitana',
    '141': 'Los Ríos',
    '151': 'Arica y Parinacota',
  };

  Object.keys(states).map(res => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Curacao cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
export function gluky_addressfield_cl_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '11': {
      '1101': 'Iquique',
      '1102': 'Alto Hospicio',
      '1103': 'Pozo Almonte',
      '1104': 'Camiña',
      '1105': 'Colchane',
      '1106': 'Huara',
      '1107': 'Pica',
    },
    '22': {
      '2201': 'Antofagasta',
      '2202': 'Mejillones',
      '2203': 'Sierra Gorda',
      '2204': 'Taltal',
      '2205': 'Calama',
      '2206': 'Ollagüe',
      '2207': 'San Pedro de Atacama',
      '2208': 'Tocopilla',
      '2209': 'María Elena',
    },
    '31': {
      '3101': 'Copiapó',
      '3102': 'Caldera',
      '3103': 'Tierra Amarilla',
      '3104': 'Chañaral',
      '3105': 'Diego de Almagro',
      '3106': 'Vallenar',
      '3107': 'Alto del Carmen',
      '3108': 'Freirina',
      '3109': 'Huasco',
    },
    '41': {
      '4101': 'La Serena',
      '4102': 'Coquimbo',
      '4103': 'Andacollo',
      '4104': 'La Higuera',
      '4105': 'Paiguano',
      '4106': 'Vicuña',
      '4107': 'Illapel',
      '4108': 'Canela',
      '4109': 'Los Vilos',
      '4110': 'Salamanca',
      '4111': 'Ovalle',
      '4112': 'Combarbalá',
      '4113': 'Monte Patria',
      '4114': 'Punitaqui',
      '4115': 'Río Hurtado',
    },
    '51': {
      '5101': 'Valparaíso',
      '5102': 'Casablanca',
      '5103': 'Concón',
      '5104': 'Juan Fernández',
      '5105': 'Puchuncaví',
      '5106': 'Quintero',
      '5107': 'Viña del Mar',
      '5108': 'Isla de Pascua',
      '5109': 'Los Andes',
      '5110': 'Calle Larga',
      '5111': 'Rinconada',
      '5112': 'San Esteban',
      '5113': 'La Ligua',
      '5114': 'Cabildo',
      '5115': 'Papudo',
      '5116': 'Petorca',
      '5117': 'Zapallar',
      '5118': 'Quillota',
      '5119': 'Calera',
      '5120': 'Hijuelas',
      '5121': 'La Cruz',
      '5122': 'Nogales',
      '5123': 'San Antonio',
      '5124': 'Algarrobo',
      '5125': 'Cartagena',
      '5126': 'El Quisco',
      '5127': 'El Tabo',
      '5128': 'Santo Domingo',
      '5129': 'San Felipe',
      '5130': 'Catemu',
      '5131': 'Llaillay',
      '5132': 'Panquehue',
      '5133': 'Putaendo',
      '5134': 'Santa María',
      '5135': 'Limache',
      '5136': 'Quilpué',
      '5137': 'Villa Alemana',
      '5138': 'Olmué',
    },
    '61': {
      '6101': 'Rancagua',
      '6102': 'Codegua',
      '6103': 'Coinco',
      '6104': 'Coltauco',
      '6105': 'Doñihue',
      '6106': 'Graneros',
      '6107': 'Las Cabras',
      '6108': 'Machalí',
      '6109': 'Malloa',
      '6110': 'Mostazal',
      '6111': 'Olivar',
      '6112': 'Peumo',
      '6113': 'Pichidegua',
      '6114': 'Quinta de Tilcoco',
      '6115': 'Rengo',
      '6116': 'Requínoa',
      '6117': 'San Vicente',
      '6118': 'Pichilemu',
      '6119': 'La Estrella',
      '6120': 'Litueche',
      '6121': 'Marchihue',
      '6122': 'Navidad',
      '6123': 'Paredones',
      '6124': 'San Fernando',
      '6125': 'Chépica',
      '6126': 'Chimbarongo',
      '6127': 'Lolol',
      '6128': 'Nancagua',
      '6139': 'Palmilla',
      '6130': 'Peralillo',
      '6131': 'Placilla',
      '6132': 'Pumanque',
      '6133': 'Santa Cruz',
    },
    '71': {
      '7101': 'Talca',
      '7102': 'Constitución',
      '7103': 'Curepto',
      '7104': 'Empedrado',
      '7105': 'Maule',
      '7106': 'Pelarco',
      '7107': 'Pencahue',
      '7108': 'Río Claro',
      '7109': 'San Clemente',
      '7110': 'San Rafael',
      '7111': 'Cauquenes',
      '7112': 'Chanco',
      '7113': 'Pelluhue',
      '7114': 'Curicó',
      '7115': 'Hualañé',
      '7116': 'Licantén',
      '7117': 'Molina',
      '7118': 'Rauco',
      '7119': 'Romeral',
      '7120': 'Sagrada Familia',
      '7121': 'Teno',
      '7122': 'Vichuquén',
      '7123': 'Linares',
      '7124': 'Colbún',
      '7125': 'Longaví',
      '7126': 'Parral',
      '7127': 'Retiro',
      '7128': 'San Javier',
      '7129': 'Villa Alegre',
      '7130': 'Yerbas Buenas',
    },
    '81': {
      '8101': 'Concepción',
      '8102': 'Coronel',
      '8103': 'Chiguayante',
      '8104': 'Florida',
      '8105': 'Hualqui',
      '8106': 'Lota',
      '8107': 'Penco',
      '8108': 'San Pedro de la Paz',
      '8109': 'Santa Juana',
      '8110': 'Talcahuano',
      '8111': 'Tomé',
      '8112': 'Hualpén',
      '8113': 'Lebu',
      '8114': 'Arauco',
      '8115': 'Cañete',
      '8116': 'Contulmo',
      '8117': 'Curanilahue',
      '8118': 'Los Alamos',
      '8119': 'Tirúa',
      '8120': 'Los Angeles',
      '8121': 'Antuco',
      '8122': 'Cabrero',
      '8123': 'Laja',
      '8124': 'Mulchén',
      '8125': 'Nacimiento',
      '8126': 'Negrete',
      '8127': 'Quilaco',
      '8128': 'Quilleco',
      '8129': 'San Rosendo',
      '8130': 'Santa Bárbara',
      '8131': 'Tucapel',
      '8132': 'Yumbel',
      '8133': 'Alto Biobío',
      '8134': 'Chillán',
      '8135': 'Bulnes',
      '8136': 'Cobquecura',
      '8137': 'Coelemu',
      '8138': 'Coihueco',
      '8139': 'Chillán Viejo',
      '8140': 'El Carmen',
      '8141': 'Ninhue',
      '8142': 'Ñiquén',
      '8143': 'Pemuco',
      '8144': 'Pinto',
      '8145': 'Portezuelo',
      '8146': 'Quillón',
      '8147': 'Quirihue',
      '8148': 'Ránquil',
      '8149': 'San Carlos',
      '8150': 'San Fabián',
      '8151': 'San Ignacio',
      '8152': 'San Nicolás',
      '8153': 'Treguaco',
      '8154': 'Yungay',
    },
    '91': {
      '9101': 'Temuco',
      '9102': 'Carahue',
      '9103': 'Cunco',
      '9104': 'Curarrehue',
      '9105': 'Freire',
      '9106': 'Galvarino',
      '9107': 'Gorbea',
      '9108': 'Lautaro',
      '9109': 'Loncoche',
      '9110': 'Melipeuco',
      '9111': 'Nueva Imperial',
      '9112': 'Padre Las Casas',
      '9113': 'Perquenco',
      '9114': 'Pitrufquén',
      '9115': 'Pucón',
      '9116': 'Saavedra',
      '9117': 'Teodoro Schmidt',
      '9118': 'Toltén',
      '9119': 'Vilcún',
      '9120': 'Villarrica',
      '9121': 'Cholchol',
      '9122': 'Angol',
      '9123': 'Collipulli',
      '9124': 'Curacautín',
      '9125': 'Ercilla',
      '9126': 'Lonquimay',
      '9127': 'Los Sauces',
      '9128': 'Lumaco',
      '9129': 'Purén',
      '9130': 'Renaico',
      '9131': 'Traiguén',
      '9132': 'Victoria',
    },
    '101': {
      '10101': 'Puerto Montt',
      '10102': 'Calbuco',
      '10103': 'Cochamó',
      '10104': 'Fresia',
      '10105': 'Frutillar',
      '10106': 'Los Muermos',
      '10107': 'Llanquihue',
      '10108': 'Maullín',
      '10109': 'Puerto Varas',
      '10110': 'Castro',
      '10111': 'Ancud',
      '10112': 'Chonchi',
      '10113': 'Curaco de Vélez',
      '10114': 'Dalcahue',
      '10115': 'Puqueldón',
      '10116': 'Queilén',
      '10117': 'Quellón',
      '10118': 'Quemchi',
      '10119': 'Quinchao',
      '10120': 'Osorno',
      '10121': 'Puerto Octay',
      '10122': 'Purranque',
      '10123': 'Puyehue',
      '10124': 'Río Negro',
      '10125': 'San Juan de la Costa',
      '10126': 'San Pablo',
      '10127': 'Chaitén',
      '10128': 'Futaleufú',
      '10129': 'Hualaihué',
      '10130': 'Palena',
    },
    '111': {
      '11101': 'Coyhaique',
      '11102': 'Lago Verde',
      '11103': 'Aisén',
      '11104': 'Cisnes',
      '11105': 'Guaitecas',
      '11106': 'Cochrane',
      '11107': "O'Higgins",
      '11108': 'Tortel',
      '11109': 'Chile Chico',
      '11110': 'Río Ibáñez',
    },
    '121': {
      '12101': 'Punta Arenas',
      '12102': 'Laguna Blanca',
      '12103': 'Río Verde',
      '12104': 'San Gregorio',
      '12105': 'Cabo de Hornos (Ex-Navarino)',
      '12106': 'Antártica',
      '12107': 'Porvenir',
      '12108': 'Primavera',
      '12109': 'Timaukel',
      '12110': 'Natales',
      '12111': 'Torres del Paine',
    },
    '131': {
      '13101': 'Santiago',
      '13102': 'Cerrillos',
      '13103': 'Cerro Navia',
      '13104': 'Conchalí',
      '13105': 'El Bosque',
      '13106': 'Estación Central',
      '13107': 'Huechuraba',
      '13108': 'Independencia',
      '13109': 'La Cisterna',
      '13110': 'La Florida',
      '13111': 'La Granja',
      '13112': 'La Pintana',
      '13113': 'La Reina',
      '13114': 'Las Condes',
      '13115': 'Lo Barnechea',
      '13116': 'Lo Espejo',
      '13117': 'Lo Prado',
      '13118': 'Macul',
      '13119': 'Maipú',
      '13120': 'Ñuñoa',
      '13121': 'Pedro Aguirre Cerda',
      '13122': 'Peñalolén',
      '13123': 'Providencia',
      '13124': 'Pudahuel',
      '13125': 'Quilicura',
      '13126': 'Quinta Normal',
      '13127': 'Recoleta',
      '13128': 'Renca',
      '13129': 'San Joaquín',
      '13130': 'San Miguel',
      '13131': 'San Ramón',
      '13132': 'Vitacura',
      '13133': 'Puente Alto',
      '13134': 'Pirque',
      '13135': 'San José de Maipo',
      '13136': 'Colina',
      '13137': 'Lampa',
      '13138': 'Tiltil',
      '13139': 'San Bernardo',
      '13140': 'Buin',
      '13141': 'Calera de Tango',
      '13142': 'Paine',
      '13143': 'Melipilla',
      '13144': 'Alhué',
      '13145': 'Curacaví',
      '13146': 'María Pinto',
      '13147': 'San Pedro',
      '13148': 'Talagante',
      '13149': 'El Monte',
      '13150': 'Isla de Maipo',
      '13151': 'Padre Hurtado',
      '13152': 'Peñaflor',
    },
    '141': {
      '14101': 'Valdivia',
      '14102': 'Corral',
      '14103': 'Lanco',
      '14104': 'Los Lagos',
      '14105': 'Máfil',
      '14106': 'Mariquina',
      '14107': 'Paillaco',
      '14108': 'Panguipulli',
      '14109': 'La Unión',
      '14110': 'Futrono',
      '14111': 'Lago Ranco',
      '14112': 'Río Bueno',
    },
    '151': {
      '15101': 'Arica',
      '15102': 'Camarones',
      '15103': 'Putre',
      '15104': 'General Lagos',
    },
  };
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map(citie => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}
